// import { z } from 'zod'

// export const Validation = z.object({
//   firstName: z.string().min(2, 'First name is required'),
//   lastName: z.string().min(2, 'Last name is required'),
//   email: z.string().email('Valid email is required'),
//   password: z.string().min(6, 'Password must be at least 6 characters'),
//   username: z.string().min(2, 'Username is required'),
//   phoneNumber: z.string().optional()
// })


import { z } from 'zod'

export const Validation = z.object({
  username: z.string().min(2, 'Username is required'),
  email: z.string().email('Valid email is required'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  confirmPassword: z.string().min(6, 'Confirm password is required'),
  phoneno: z.string().min(10, 'Phone number is required'),
  gender: z.string().min(1, 'Gender is required'),
  dateOfBirth: z.string().min(1, 'Date of birth is required'),
  userType: z.string().default('fan'),
  cityState: z.string().min(1, 'City/State is required'),
  country: z.string().min(1, 'Country is required')
})

export const EditValidation = z.object({
  username: z.string().min(2, 'Username is required'),
  email: z.string().email('Valid email is required'),
  phoneno: z.string().min(10, 'Phone number is required'),
  gender: z.string().min(1, 'Gender is required'),
  dateOfBirth: z.string().min(1, 'Date of birth is required'),
  userType: z.string().default('fan'),
  cityState: z.string().min(1, 'City/State is required'),
  country: z.string().min(1, 'Country is required')
});
